// extracted by mini-css-extract-plugin
module.exports = {"detail_new":"styles_detail_new__1fs5l","header":"styles_header__1G2NZ","back":"styles_back__2HHXX","title":"styles_title__1bWJc","content":"styles_content__1pPSJ"};